import styled from "styled-components";
import {motion} from "framer-motion";
import image from './../../assets/itemLeader.png';
import {ILeaderEntity} from "./Leaderbord";
import defaultAvatar from './../../assets/defaultAvatar.png';

const variantsItem = {
    open: {
        y: 0,
        opacity: 1,
        transition: {
            y: {stiffness: 1000, velocity: -100}
        }
    },
    closed: {
        y: 50,
        opacity: 0,
        transition: {
            y: {stiffness: 1000}
        }
    }
};

const Row = styled(motion.div)<{stickyUser?: boolean}>`
    padding: 8px 16px;
    min-height: 50px;
    display: flex;
    flex-direction: row;
    bottom: ${({stickyUser}) => stickyUser ? '-8px' : '0'};
    align-items: center;
    position: ${({stickyUser}) => stickyUser ? 'sticky' : 'relative'};
    filter: ${({stickyUser}) => stickyUser ? 'sepia(1)' : 'none'};
    
    @media (min-width: 1024px) {
        min-height: 80px;
    }
`;

const FilledGround = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    height: 100%;
    width: 100%;

    -webkit-user-select: none; /* Safari */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-tap-highlight-color: transparent;

    pointer-events: none; /* Prevent any interactions */
    user-drag: none; /* Disable image dragging */
    -webkit-user-drag: none; /* Disable image dragging for Safari */
`;

const AvatarContainer = styled.div`
    overflow: hidden;
    border-radius: 50%;
    margin-right: 16px;
`;

const Avatar = styled.img`
    height: 40px;
    width: 40px;
    background-color: transparent;

    -webkit-user-select: none; /* Safari */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-tap-highlight-color: transparent;

    pointer-events: none; /* Prevent any interactions */
    user-drag: none; /* Disable image dragging */
    -webkit-user-drag: none; /* Disable image dragging for Safari */

    @media (min-width: 1024px) {
        height: 65px;
        width: 65px;
    }
`;

const FullName = styled.div`
    flex-grow: 1;
    font-weight: 900;
    color: #1c188c;

    @media (min-width: 1024px) {
        font-size: 30px;
    }
`;

const Score = styled.div`
    font-weight: 900;
    color: #1c188c;

    @media (min-width: 1024px) {
        font-size: 30px;
    }
`;

interface Props {
    item: ILeaderEntity;
    sticky?: boolean;
}

export const Item = ({item, sticky}: Props) => {
    const avatarUrl = item.player.getAvatarSrc('small') || defaultAvatar;
    const fullName = item.player.publicName || 'unknown'

    return (
        <Row variants={variantsItem} stickyUser={sticky}>
            <FilledGround src={image} />
            <AvatarContainer>
                <Avatar src={avatarUrl} />
            </AvatarContainer>
            <FullName>{fullName.length > 15 ? `${fullName.slice(0, 15)}...` : fullName}</FullName>
            <Score>{item.score || item.formattedScore || '0'}</Score>
        </Row>
    )
}